/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MonitorStatusDto = {
    latestRunDate?: number | null;
    monitorStatus: MonitorStatusDto.monitorStatus;
};

export namespace MonitorStatusDto {

    export enum monitorStatus {
        NOT_EVALUATED = 'NOT_EVALUATED',
        PASSING = 'PASSING',
        NEEDS_ATTENTION = 'NEEDS_ATTENTION',
        FAILING = 'FAILING',
    }


}
